import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { IStation } from "Types/station";

interface IState {
  reportRightSideMode: number;
  reportLeftSideMode: number;
  showReportRightControl: boolean;
  showReportLeftControl: boolean;
  supportLeftSideMode: number;
  showSupportLeftControl: boolean;
  showSupportLeftSide: boolean;
  showPaths: boolean;
  starMiniDashUrl: string;
  starFullDashUrl: string;
}

const initialState: IState = {
  reportRightSideMode: 1,
  reportLeftSideMode: 1,
  showReportRightControl: false,
  showReportLeftControl: false,
  supportLeftSideMode: 1,
  showSupportLeftControl: false,
  showSupportLeftSide: false,
  showPaths: true,
  starMiniDashUrl: "",
  starFullDashUrl: "",
};

export const sideSlice = createSlice({
  name: "side",
  initialState,
  reducers: {
    changeReportRightSideMode: (state, action: PayloadAction<number>) => {
      return { ...state, reportRightSideMode: action.payload };
    },
    changeReportLeftSideMode: (state, action: PayloadAction<number>) => {
      return { ...state, reportLeftSideMode: action.payload };
    },
    changeShowReportRightControl: (state, action: PayloadAction<boolean>) => {
      return { ...state, showReportRightControl: action.payload };
    },
    changeShowReportLeftControl: (state, action: PayloadAction<boolean>) => {
      return { ...state, showReportLeftControl: action.payload };
    },
    changeSupportLeftSideMode: (state, action: PayloadAction<number>) => {
      return { ...state, supportLeftSideMode: action.payload };
    },
    changeShowSupportLeftControl: (state, action: PayloadAction<boolean>) => {
      return { ...state, showSupportLeftControl: action.payload };
    },
    changeShowSupportLeftSide: (state, action: PayloadAction<boolean>) => {
      return { ...state, showSupportLeftSide: action.payload };
    },
    changeShowPaths: (state, action: PayloadAction<boolean>) => {
      return { ...state, showPaths: action.payload };
    },
    setStarMiniDashUrl: (state, action: PayloadAction<string>) => {
      return { ...state, starMiniDashUrl: action.payload };
    },
    setStarFullDashUrl: (state, action: PayloadAction<string>) => {
      return { ...state, starFullDashUrl: action.payload };
    },
  },
});

export const {
  changeReportRightSideMode,
  changeReportLeftSideMode,
  changeShowReportRightControl,
  changeShowReportLeftControl,
  changeSupportLeftSideMode,
  changeShowSupportLeftControl,
  changeShowSupportLeftSide,
  changeShowPaths,
  setStarMiniDashUrl,
  setStarFullDashUrl,
} = sideSlice.actions;

export default sideSlice.reducer;
